'use client'

import React from 'react'

import {
  ColorKeysWithoutGradient,
  GapProps,
  SpaceProps,
  Theme,
} from '../../themes'
import { Container } from './styles'

export interface BaseTypographyProps {
  /**
   * ID attribute
   */
  id?: string

  /**
   * HTML title attribute
   */
  title?: string

  /**
   * Class name
   */
  className?: string

  /**
   * Typography variant
   */
  variant?: keyof Theme['typography']

  /**
   * Content
   */
  children: React.ReactNode

  /**
   * HTML tag
   */
  as?: keyof HTMLElementTagNameMap

  /**
   * Override text color
   */
  color?: ColorKeysWithoutGradient<Theme>

  /**
   * Text align
   */
  textAlign?: 'left' | 'center' | 'right'

  /**
   * Word break
   */
  wordBreak?: 'normal' | 'break-all'

  /**
   * Inline flex
   */
  inlineFlex?: boolean
}

export type TypographyProps = BaseTypographyProps & SpaceProps & GapProps

/**
 * Typography component
 */
export const Typography = ({
  id,
  as = 'span',
  variant = 'body1',
  className,
  color,
  children,
  ...rest
}: TypographyProps) => (
  <Container
    as={as}
    variant={variant}
    id={id}
    className={className}
    textColor={color}
    {...rest}
  >
    {children}
  </Container>
)
